export class State {
	public static currentView: any = {};
	public static assetsToLoad: any = [];
	public static loadedAssets: any = [];
}
